// Library Imports
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/store';

// Local Imports
import assets from '../../assets';
import { Alert, Button, TextField } from '../shared';
import { resetPasswordAPI } from '../../redux/features/auth/authSlice';

interface ResetPassFromDataType {
    newPassword: string;
}

const ResetPasswordForm = () => {
    const dispatch = useAppDispatch();
    const { loading, error } = useAppSelector((state) => state.authUser);

    // GET Token From URL
    const urlParams = new URLSearchParams(window.location.search);
    const queryParamValue = urlParams?.get('token');

    // States
    const [resetPassFormData, setResetPassFormData] = useState<ResetPassFromDataType>({
        newPassword: '',
    });
    const [isShowAlert, setIsShowAlert] = useState<boolean>(false);
    const [isRequestSend, setIsRequestSend] = useState<boolean>(false);
    const [emptyData, setEmptyData] = useState<any>([]);

    // Empty Check Fn
    const emptyCheck = () => {
        let isEmpty: any = {};
        Object.values(resetPassFormData).map((item, index) => {
            if (item === null || item === '') {
                isEmpty = {
                    ...isEmpty,
                    [Object.keys(resetPassFormData)[index]]: true,
                };
            }
            return item;
        });
        setEmptyData(isEmpty);

        return isEmpty ? (Object.keys(isEmpty).length === 0 ? false : true) : false;
    };

    // Handle FieldChange Fn
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setResetPassFormData({ ...resetPassFormData, [name]: value });
        setEmptyData({
            ...emptyData,
            [name]: false,
        });
        setIsShowAlert(false);
    };

    // Handle ResetPassword Fn
    const handleResetPassword = async () => {
        setIsShowAlert(false);
        if (!emptyCheck() && queryParamValue) {
            const data = await dispatch(resetPasswordAPI({
                token: queryParamValue,
                newPassword: resetPassFormData.newPassword
            }));
            if (data.meta.requestStatus === 'rejected') {
                setIsShowAlert(true);
                return
            }
            setIsRequestSend(true);
        }
    };

    // UseEffect 
    useEffect(() => {
        const listener = (event: KeyboardEvent) => {
            if ((event.code === "Enter" || event.code === "NumpadEnter") && !isRequestSend) {
                event.preventDefault();
                handleResetPassword();
                console.log('hello')
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetPassFormData, isRequestSend]);

    return (
        <React.Fragment>
            <div className='h-full w-full flex flex-col items-center justify-center gap-3'>
                {/* LOGO */}
                <div className='w-[150px]'>
                    <Link to='/'>
                        <img src={assets.logo} className='object-fit' alt='Rylyf' />
                    </Link>
                </div>

                {/* Form Section */}
                <section className='w-full max-w-md rounded-xl'>
                    <div className='container flex items-center justify-center px-6 mx-auto'>
                        <div className='w-full max-w-md'>
                            {/* LOGO Name */}
                            <div className='flex flex-col items-center justify-center'>
                                <h1 className='text-2xl font-normal text-gray-800 capitalize sm:text-2xl'>
                                    Reset Password
                                </h1>
                                {isRequestSend ?
                                    <p className='text-base text-center text-gray-500 mt-4'>
                                        Password Changed Successfully
                                    </p> :
                                    <p className='text-base text-center text-gray-500 mt-1'>Please enter your New Password</p>
                                }
                            </div>

                            <Alert color='danger' text={error ? error : ''} showAlert={isShowAlert} setShowAlert={setIsShowAlert} />

                            {/* Login Fields */}
                            {!isRequestSend && <div className='relative flex flex-col items-center mt-4 gap-4'>
                                <TextField
                                    name={'newPassword'}
                                    value={resetPassFormData?.newPassword}
                                    type='password'
                                    placeholder='Password'
                                    icon={true}
                                    onChange={handleOnChange}
                                    error={emptyData?.newPassword || isShowAlert ? true : false}
                                    errorMsg={emptyData?.newPassword && 'Password is required'}
                                />
                            </div>}

                            {/* Button Section */}
                            <div className='mt-4'>
                                {isRequestSend ?
                                    <Link
                                        to='/login'
                                        className='text-sm no-underline'
                                    >
                                        <Button variant={'primary'} fullWidth disabled={loading} onClick={() => setIsShowAlert(false)}>
                                            Done
                                        </Button>
                                    </Link>
                                    :
                                    <Button onClick={handleResetPassword} variant='primary' fullWidth loading={loading}>
                                        Update Password
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </React.Fragment>
    );
};

export default ResetPasswordForm;
